import React from 'react';

const PrivacyPolicy = () => {
  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headerStyle = {
    textAlign: 'center',
    fontSize: '2em',
    fontWeight: '550'
  };

  const subHeaderStyle = {
    marginTop: '1.5em',
    fontSize: '1.5em',
  };

  const paragraphStyle = {
    fontSize: '1.1em',
    lineHeight: '1.6',
  };

  const ulStyle = {
    listStyleType: 'disc',
    paddingLeft: '20px',
  };

  const sectionStyle = {
    marginBottom: '1.5em',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Data Consent</h1>
      <p>Consent to Use of Data</p>
        <p>You agree that Intelirain Inc. (“Intelirain”) may collect and use technical data and related information, 
        including but not limited to technical information about your device, system and application software, and peripherals, 
        that is gathered periodically to facilitate the provision of software updates, product support and other services to you (if any) related to your device. 
        Intelirain may use this information, as long as it is in a form that does not personally identify you, to improve its products or to provide services or technologies to you.
    </p>
    </div>
  );
};

export default PrivacyPolicy;
